export function isDevEnvironment(){
    return process.env.NODE_ENV !== 'production'
}
